export default __webpack_public_path__ + "static/media/login-step1.59b70909.svg";